import { useEffect } from 'react'


const Colors = () => {
    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])


    return (
        <>
            <section className="Screen__Colors Container-FullHeight">
                <div>
                    {/* <img src="/img/page/adsl-five.png" className="LogoADSL Screen__Colors__Logo" alt="Logo" /> */}
                    <img src="/img/page/adsl-five.png" className="d-block mx-auto w-25" alt="Logo" />
                    <p className="Screen__Colors__Title">Prepara tu celular y disfruta la vista</p>

                    <div className='container Screen__Colors__Container'>
                        <div>
                            <p className="Screen__Colors__Text mb-0">Sube el brillo</p>
                            <img src='/img/page/subir-brillo.png' className='Screen__Colors__Image' alt='subir-brillo' />
                        </div>
                        <div className='Screen__Colors__Container__DivisorLine'>
                            <div className='Screen__Colors__Container__DivisorLine__Line'></div>
                        </div>
                        <div>
                            <p className="Screen__Colors__Text">Voltéalo</p>
                            <img src="/img/page/voltear-celular.png" className="Screen__Colors__Image" alt="Logo" />
                        </div>
                    </div>
                </div>
            </section>

            <footer className='Screen__Colors'>
                <p className='text-center FooterCredits'>Hecho con ♥ por Five Digital Minds | 2026</p>
            </footer>
        </>
    )
}

export { Colors };